/* BeeDTF · Transfers by size
   Multi-design configurator: upload -> measure -> pick size (best fit / box / custom) -> finish -> qty.
   Price per transfer = variant "Up to N in² / Finish" covering width × height. Bulk tiers count all designs. */
(() => {
  const ICON_CHEV = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 15 6-6 6 6"/></svg>';
  const ICON_X = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
  const ICON_LOCK = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>';
  const ICON_CHECK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12 5 5 9-10"/></svg>';
  const ICON_PEN = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 20h4L19 9l-4-4L4 16z"/><path d="m13.5 6.5 4 4"/></svg>';
  /* T-shirt outline drawn in inches (adult M, ~20″ chest) so the design renders at true scale. */
  const SHIRT = 'M13.6 1.2C15 3.3 21 3.3 22.4 1.2L28.6 2.9C31 3.8 33.6 6.8 35.2 10L31.2 12.6 28.3 9.6 28.6 32.4C22 33.2 14 33.2 7.4 32.4L7.7 9.6 4.8 12.6.8 10C2.4 6.8 5 3.8 7.4 2.9Z';
  const SHIRT_COLORS = [['White', '#FFFFFF'], ['Black', '#1C1C1C'], ['Heather Gray', '#A7A9AC'], ['Navy', '#1F2A44'], ['Red', '#C8102E']];
  /* Products the design can be previewed on. Drawn in inches, so the print shows at true scale.
     fit = typical print area: the recommended size stays inside it and bigger sizes get a gentle warning. */
  const LINE = 'rgba(0,0,0,.18)';
  /* real product photos live next to this script in the theme's assets */
  const ASSETS = ((document.currentScript && document.currentScript.src) || '').replace(/beedtf-bysize\.js.*$/, '');
  const GARMENTS = {
    tee: {
      name: 'T-shirt', vb: '0 0 36 34', w: 36, body: SHIRT, auto: true, colors: SHIRT_COLORS,
      over: () => `<path d="M13.2 1.1C14.8 4.1 21.2 4.1 22.8 1.1" fill="none" stroke="${LINE}" stroke-width=".55"/>`,
      ruler: { y: 30.6, x0: 7.9, x1: 28.1, text: '20″ chest · adult M' },
      places: { center: { cx: 18, y: 5.4 }, left: { cx: 22.6, y: 5.2 }, right: { cx: 13.4, y: 5.2 } },
      box: { x0: 6, x1: 30, y0: 1.5, y1: 30 }
    },
    hoodie: {
      name: 'Hoodie', vb: '0 0 36 35', w: 36, auto: true, colors: SHIRT_COLORS,
      body: 'M13 2.4C14.6 3.8 21.4 3.8 23 2.4L28.8 3.8C31.4 4.8 33.2 8.2 34.2 13.4L35 27.6 31.4 28 29.6 14.4 28.8 33.6C22.2 34.4 13.8 34.4 7.2 33.6L6.4 14.4 4.6 28 1 27.6 1.8 13.4C2.8 8.2 4.6 4.8 7.2 3.8Z',
      under: (c) => `<path d="M11.8 3.2C11.6-.4 24.4-.4 24.2 3.2 22.6 5.6 13.4 5.6 11.8 3.2Z" fill="${c}" stroke="${LINE}" stroke-width=".12"/>`,
      over: () => `<path d="M13.8 3.1C15 5.9 21 5.9 22.2 3.1" fill="none" stroke="${LINE}" stroke-width=".35"/><path d="M16.7 4.9V6.9M19.3 4.9V6.9" stroke="rgba(0,0,0,.3)" stroke-width=".16" stroke-linecap="round"/><path d="M11.8 21.6H24.2L26.4 29.4H9.6Z" fill="none" stroke="${LINE}" stroke-width=".14"/><path d="M7.3 32.2H28.7" stroke="${LINE}" stroke-width=".12"/>`,
      ruler: { y: 31.4, x0: 7.9, x1: 28.1, text: '20″ chest · adult M' },
      places: { center: { cx: 18, y: 7.4 }, left: { cx: 22.6, y: 7 }, right: { cx: 13.4, y: 7 } },
      box: { x0: 9, x1: 27, y0: 5, y1: 21.4 },
      fit: { w: 12, h: 11, where: 'hoodie front (above the pocket)' }
    },
    hat: {
      name: 'Hat', vb: '0 0 12 8', w: 12,
      colors: [['Black', '#1C1C1C'], ['White', '#FFFFFF'], ['Navy', '#1F2A44'], ['Khaki', '#C3B091'], ['Red', '#C8102E']],
      body: 'M2.2 5.9C2.2 3.1 3.8 1.3 6 1.3S9.8 3.1 9.8 5.9Z',
      over: (c) => `<path d="M6 1.35C4.8 2.5 4.2 4.1 4 5.85M6 1.35C7.2 2.5 7.8 4.1 8 5.85" fill="none" stroke="${LINE}" stroke-width=".06"/><circle cx="6" cy="1.32" r=".26" fill="${c}" stroke="${LINE}" stroke-width=".06"/>`
        + `<path d="M1.9 5.7C3.9 5.3 8.1 5.3 10.1 5.7L10.5 6.6C8.6 7.7 3.4 7.7 1.5 6.6Z" fill="${c}" stroke="${LINE}" stroke-width=".06"/><path d="M2.2 6.2C4.1 5.85 7.9 5.85 9.8 6.2" fill="none" stroke="${LINE}" stroke-width=".05" stroke-dasharray=".15 .1"/>`,
      places: { center: { cx: 6, y: 2.9 } }, centerName: 'Front',
      box: { x0: 3, x1: 9, y0: 1.8, y1: 5.6 },
      fit: { w: 4.5, h: 2.5, where: 'hat front' }
    },
    tote: {
      /* 15″ W × 16″ H × 3″ D canvas tote (Everyday Canvas Tote photo: 1000 px = 30.5″, 32.8 px per inch); imprint area 10″ × 12″ */
      name: 'Tote bag', short: 'Tote', vb: '3.65 1.9 23 27.5', w: 23, img: 30.49,
      photo: 'https://cdn.shopify.com/s/files/1/0715/2202/5543/files/tg200-everyday-canvas-tote-flat.jpg?width=1000',
      colors: [['Natural', '#EFE6D2']],
      places: { center: { cx: 15.15, cy: 19.3 } }, centerName: 'Center',
      area: { x: 10.15, y: 13.3, w: 10, h: 12 },
      box: { x0: 10.15, x1: 20.15, y0: 12.1, y1: 27.5 },
      fit: { w: 10, h: 12, where: 'tote bag imprint area' }
    }
  };
  /* one code per visitor (kept 7 days) so all of their uploads land in the same Drive folder */
  const SESSION = (() => {
    try { const s = JSON.parse(localStorage.getItem('bee_session') || 'null'); if (s && s.id && Date.now() - s.t < 7 * 864e5) return s.id; } catch (e) { /* ignore */ }
    const id = 'S' + Math.random().toString(36).slice(2, 8).toUpperCase();
    try { localStorage.setItem('bee_session', JSON.stringify({ id, t: Date.now() })); } catch (e) { /* ignore */ }
    return id;
  })();
  const isLight = (hex) => {
    const n = parseInt(hex.slice(1), 16);
    return (0.299 * (n >> 16) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255)) / 255 > 0.6;
  };

  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const data = JSON.parse(root.querySelector('[data-json]').textContent);
    const addUrl = root.dataset.addUrl || '/cart/add';
    const cartUrl = root.dataset.cartUrl || '/cart';
    const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: data.currency || 'USD' });
    const fmt = (c) => money.format(c / 100);
    const r1 = (n) => Math.round(n * 10) / 10;
    const f1 = (n) => Math.floor(n * 10 + 1e-6) / 10;
    const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const $ = (s) => root.querySelector(s);
    const IN = '″';

    /* ---------- price table from variants ---------- */
    const fins = { roll: [], precut: [] };
    data.variants.forEach((v) => {
      const area = parseFloat((String(v.option1 || '').match(/(\d+(?:\.\d+)?)/) || [])[1]);
      if (!area) return;
      const o2 = String(v.option2 || '').toLowerCase();
      const key = o2.includes('pre') ? 'precut' : 'roll';
      fins[key].push({ area, id: v.id, price: v.price, available: v.available });
    });
    Object.values(fins).forEach((l) => l.sort((a, b) => a.area - b.area));
    const hasPrecut = fins.precut.length > 0;
    const maxArea = fins.roll.length ? fins.roll[fins.roll.length - 1].area : 0;
    const precutFee = hasPrecut ? fins.precut[0].price - fins.roll[0].price : 0;
    const tierFor = (area, fin) => ((fin === 'precut' && hasPrecut) ? fins.precut : fins.roll).find((t) => area <= t.area + 1e-6) || null;

    const breaks = (data.tiers || []).filter((t) => t && t.qty > 0).sort((a, b) => a.qty - b.qty);
    const tierInfo = (q) => {
      let cur = { qty: 0, pct: 0 }, next = null;
      for (const t of breaks) { if (q >= t.qty) cur = t; else { next = t; break; } }
      return { cur, next };
    };

    const groups = (data.groups || []).map((g) => ({
      title: g.title, sub: g.sub,
      sizes: String(g.sizes || '').split(',').map((s) => s.trim().toLowerCase().split('x').map(parseFloat)).filter((p) => p.length === 2 && p[0] > 0 && p[1] > 0)
    })).filter((g) => g.sizes.length);

    /* ---------- elements ---------- */
    const form = $('[data-form]');
    const fileInput = $('[data-file]');
    const drop = $('[data-drop]');
    const dropTitle = $('[data-drop-title]');
    const list = $('[data-list]');
    const dropHome = document.createComment('drop');
    drop.before(dropHome);
    const bulk = $('[data-bulk]');
    const nudge = $('[data-nudge]');
    const breaksEl = $('[data-breaks]');
    const totalEl = $('[data-total]');
    const totalMeta = $('[data-total-meta]');
    const addBtn = $('[data-add]');
    const addLabel = $('[data-add-label]');
    const addText = addLabel.textContent;
    if (!document.getElementById('bee-buzz-css')) { const st = document.createElement('style'); st.id = 'bee-buzz-css'; st.textContent = `.bee-buzz{display:inline-block;animation:bee-buzz .18s linear infinite}@keyframes bee-buzz{0%,100%{transform:translate(0,0) rotate(0)}25%{transform:translate(.7px,-.6px) rotate(-2deg)}50%{transform:translate(-.6px,.5px) rotate(1.5deg)}75%{transform:translate(.5px,.7px) rotate(-1deg)}}@media (prefers-reduced-motion:reduce){.bee-buzz{animation:none}}`; document.head.appendChild(st); }
    const errFile = $('[data-err="file"]');
    const errSubmit = $('[data-err="submit"]');
    const stage = $('[data-stage]');
    const preview = $('[data-preview]');
    const previewImg = $('[data-preview-img]');
    const previewName = $('[data-preview-name]');
    const dimW = $('[data-dim-w]');
    const dimH = $('[data-dim-h]');
    const bar = $('[data-bar]');
    const barTotal = $('[data-bar-total]');
    const barInfo = $('[data-bar-info]');
    const barBtn = $('[data-bar-btn]');

    const mockEl = $('[data-mock]');
    const mockCap = $('[data-mock-cap]');
    const flatEl = $('[data-flat]');
    const colorWrap = $('[data-colors]');
    const viewBtns = [...root.querySelectorAll('[data-view]')];
    let shirt = { name: SHIRT_COLORS[0][0], hex: SHIRT_COLORS[0][1] };
    let view = 'shirt';
    let colorBtns = [];
    if (colorWrap) {
      colorWrap.addEventListener('click', (e) => {
        const b = e.target.closest('[data-color]');
        if (!b) return;
        shirt = { name: b.dataset.name, hex: b.dataset.color };
        render();
      });
    }
    viewBtns.forEach((b) => b.addEventListener('click', () => { view = b.dataset.view; showPreview(); }));
    let lastGarment = 'tee';
    const G = (d) => GARMENTS[(d && d.garment) || 'tee'];
    const colorOf = (g) => g.colors.find((c) => c[1] === shirt.hex) || g.colors[0];
    let colorsFor = null;
    const syncColors = (g) => {
      if (!colorWrap || colorsFor === g) return;
      colorsFor = g;
      colorWrap.innerHTML = g.colors.map(([n, h]) => `<button type="button" data-color="${h}" data-name="${esc(n)}" aria-pressed="false" title="${esc(n)}" style="--c:${h}"><span class="bee-sr">${esc(n)}</span></button>`).join('');
      colorBtns = [...colorWrap.querySelectorAll('[data-color]')];
    };
    const garBtnsHTML = (cur, attr) => Object.entries(GARMENTS).map(([k, g]) => `<button type="button" ${attr}="${k}" aria-pressed="${k === cur}">${esc(g.short || g.name)}</button>`).join('');
    const setGarment = (d, k) => {
      if (!d || !GARMENTS[k] || G(d) === GARMENTS[k]) return;
      d.garment = k;
      d.pos = null;
      lastGarment = k;
      const [n, h] = colorOf(GARMENTS[k]);
      shirt = { name: n, hex: h };
    };
    let garWrap = null;
    if (viewBtns.length) {
      garWrap = document.createElement('div');
      garWrap.className = 'bee-bs__places bee-bs__gar';
      garWrap.setAttribute('role', 'group');
      garWrap.setAttribute('aria-label', 'Preview on');
      viewBtns[0].parentNode.after(garWrap);
      garWrap.addEventListener('click', (e) => {
        const b = e.target.closest('[data-gar]');
        if (!b) return;
        setGarment(designs.find((x) => x.key === activeKey), b.dataset.gar);
        render();
      });
    }
    let placeBtns = [];
    if (colorWrap) {
      const places = document.createElement('div');
      places.className = 'bee-bs__places';
      places.setAttribute('role', 'group');
      places.setAttribute('aria-label', 'Placement');
      places.innerHTML = '<button type="button" data-place="center">Center</button><button type="button" data-place="left">Left chest</button><button type="button" data-place="right">Right chest</button>';
      colorWrap.parentNode.insertBefore(places, colorWrap);
      placeBtns = [...places.querySelectorAll('[data-place]')];
      places.addEventListener('click', (e) => {
        const b = e.target.closest('[data-place]');
        const d = designs.find((x) => x.key === activeKey);
        if (!b || !d || !G(d).places[b.dataset.place]) return;
        d.pos = G(d).places[b.dataset.place];
        render();
      });
    }

    const designs = [];
    let activeKey = null;
    let seq = 0;

    /* ---------- sizing ---------- */
    const fitBox = (d, bw, bh) => {
      if (!d.ratio) return { w: bw, h: bh };
      let w = Math.min(bw, bh / d.ratio);
      let h = w * d.ratio;
      return { w: f1(w), h: f1(h) };
    };
    const sharpFit = (d) => {
      if (!d.px || d.vector) return null;
      const w = d.px.w / data.dpi, h = d.px.h / data.dpi;
      const k = Math.min(1, data.maxSize / w, data.maxSize / h);
      return { w: f1(w * k), h: f1(h * k) };
    };
    /* recommended size: as big as prints sharp, but inside the product's typical print area */
    const bestFit = (d) => {
      const s = sharpFit(d);
      const fit = G(d).fit;
      if (!s || !fit) return s;
      const k = Math.min(1, fit.w / s.w, fit.h / s.h);
      return k < 1 ? { w: f1(s.w * k), h: f1(s.h * k) } : s;
    };
    const sizeOf = (d) => {
      if (d.mode === 'best') return bestFit(d);
      if (d.mode === 'box') return fitBox(d, d.box[0], d.box[1]);
      if (d.mode === 'custom') return (d.w > 0 && d.h > 0) ? { w: r1(d.w), h: r1(d.h) } : null;
      return null;
    };
    /* quality check: protects the customer (and us) from blurry or stretched prints */
    const sigOf = (sz) => (sz ? `${sz.w}x${sz.h}` : '');
    const quality = (d, sz) => {
      const q = { level: 'ok', msgs: [], tags: [], dpi: null };
      if (!sz) return q;
      if (d.ratio && Math.abs(sz.h - sz.w * d.ratio) > Math.max(0.06, 0.03 * sz.h)) {
        q.level = 'bad';
        q.msgs.push(`<strong>Your design will be stretched.</strong> ${sz.w}${IN} × ${sz.h}${IN} doesn’t match your design’s shape. Tap the lock to keep its proportions.`);
        q.tags.push('Stretched');
      }
      if (d.px && !d.vector) {
        const dpi = Math.round(Math.min(d.px.w / sz.w, d.px.h / sz.h));
        q.dpi = dpi;
        const sharp = sharpFit(d);
        const hint = sharp ? ` It prints sharp up to ${sharp.w}${IN} × ${sharp.h}${IN}.` : '';
        if (dpi < 150) {
          if (q.level === 'ok') q.level = 'soft';
          q.msgs.push(dpi < 75
            ? `<strong>Your file is small for this size, so it may print soft.</strong> We check every file before printing and will email you if a bigger file would look better.`
            : `<strong>May look a little soft at this size.</strong> Fine for most shirts. We check every file before printing.`);
          q.tags.push(`Low resolution (${dpi} DPI)`);
        }
      }
      const fit = G(d).fit;
      if (fit && (sz.w > fit.w + 0.05 || sz.h > fit.h + 0.05)) {
        if (q.level === 'ok') q.level = 'soft';
        q.msgs.push(`<strong>Bigger than a typical ${esc(fit.where)}.</strong> Most fit up to ${fit.w}${IN} × ${fit.h}${IN}. Check your item, or pick a smaller size.`);
      }
      return q;
    };
    const acked = (d, sz) => d.ackFor === sigOf(sz);

    /* ---------- file upload: big print files go to Google Drive, a small preview goes to Shopify ---------- */
    const SHOPIFY_MAX = 20 * 1024 * 1024;
    const productName = String(((root.querySelector('h1') || {}).textContent || data.product || 'DTF transfer')).trim().replace(/\s+/g, ' ').slice(0, 60);
    const SMALL_MAX = 35 * 1024 * 1024;
    const up = data.upload || {};
    const mb = (b) => `${(b / 1048576).toFixed(b < 10485760 ? 1 : 0)} MB`;
    const post = (body) => fetch(up.url, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify({ key: up.key, ...body }) })
      .then((r) => r.json());
    const putFile = (url, file, onp) => new Promise((resolve, reject) => {
      const x = new XMLHttpRequest();
      x.open('PUT', url);
      x.setRequestHeader('Content-Type', file.type || 'application/octet-stream');
      x.upload.onprogress = (e) => { if (e.lengthComputable) onp(e.loaded / e.total); };
      x.onload = () => {
        if (x.status === 200 || x.status === 201) { try { resolve(JSON.parse(x.responseText)); } catch (e) { reject(e); } }
        else reject(new Error(`Upload failed (${x.status})`));
      };
      x.onerror = () => reject(new Error('Upload blocked'));
      x.send(file);
    });
    const toB64 = (file) => new Promise((resolve, reject) => {
      const r = new FileReader();
      r.onload = () => resolve(String(r.result).split(',')[1] || '');
      r.onerror = reject;
      r.readAsDataURL(file);
    });
    const paintUp = (d) => {
      const j = d.job;
      const el = d.el && d.el.querySelector('[data-c-up]');
      if (!el) return;
      const state = j ? j.state : '';
      el.className = `bee-bs__up is-${state}`;
      el.textContent = !j ? '' : state === 'busy' ? `Bzzz… uploading your file ${Math.round(j.pct * 100)}%`
        : state === 'done' ? `✓ File uploaded (${mb(j.file.size)})`
        : state === 'error' ? (j.file.size > SHOPIFY_MAX ? 'Upload failed. Please remove this file and try again.' : '') : '';
      const bar = d.el.querySelector('[data-c-bar]');
      if (bar) bar.style.setProperty('--p', state === 'done' ? 1 : (j ? j.pct : 0));
      d.el.classList.toggle('is-uploading', state === 'busy');
    };
    const startUpload = (d, file) => {
      const job = { file, state: 'busy', pct: 0 };
      const set = (state, pct) => { job.state = state; job.pct = pct || 0; if (d.job === job) paintUp(d); };
      job.promise = (async () => {
        const base = { ref: d.ref, session: SESSION, name: file.name, type: file.type || 'application/octet-stream', size: file.size, origin: location.origin, product: productName, label: '' };
        set('busy', 0);
        try {
          const init = await post({ action: 'init', ...base });
          if (!init.ok) throw new Error(init.error || 'init');
          const res = await putFile(init.uploadUrl, file, (p) => set('busy', p * 0.99));
          if (!res.id) throw new Error('No file id');
          set('done', 1);
          return `https://drive.google.com/file/d/${res.id}/view`;
        } catch (e1) {
          if (file.size > SMALL_MAX) { set('error'); throw e1; }
          try {
            set('busy', 0.3);
            const r = await post({ action: 'small', ...base, data: await toB64(file) });
            if (!r.ok) throw new Error(r.error || 'small');
            set('done', 1);
            return r.url;
          } catch (e2) { set('error'); throw e2; }
        }
      })();
      job.promise.catch(() => {});
      return job;
    };

    /* ---------- design clean-up: trim empty space, remove a solid background ---------- */
    const frame = () => new Promise((r) => { let done = false; const go = () => { if (!done) { done = true; setTimeout(r, 30); } }; requestAnimationFrame(go); setTimeout(go, 120); });
    const loadImg = (url) => new Promise((resolve, reject) => { const i = new Image(); i.onload = () => resolve(i); i.onerror = reject; i.src = url; });
    const analyze = (img) => {
      const W = img.naturalWidth, H = img.naturalHeight;
      const k = Math.min(1, 900 / Math.max(W, H));
      const w = Math.max(1, Math.round(W * k)), h = Math.max(1, Math.round(H * k));
      const c = document.createElement('canvas'); c.width = w; c.height = h;
      const g = c.getContext('2d', { willReadFrequently: true });
      g.drawImage(img, 0, 0, w, h);
      const a = g.getImageData(0, 0, w, h).data;
      let border = 0, clear = 0;
      const bins = new Map();
      const visit = (x, y) => {
        const i = (y * w + x) * 4;
        border++;
        if (a[i + 3] < 24) { clear++; return; }
        const key = ((a[i] >> 4) << 8) | ((a[i + 1] >> 4) << 4) | (a[i + 2] >> 4);
        bins.set(key, (bins.get(key) || 0) + 1);
      };
      for (let x = 0; x < w; x++) { visit(x, 0); visit(x, h - 1); }
      for (let y = 1; y < h - 1; y++) { visit(0, y); visit(w - 1, y); }
      const opaque = border - clear;
      let top = 0;
      bins.forEach((n) => { if (n > top) top = n; });
      const hasBg = opaque / border > 0.6;
      const solidBg = hasBg && top / Math.max(1, opaque) > 0.55;
      let x0 = w, y0 = h, x1 = -1, y1 = -1;
      for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) {
        if (a[(y * w + x) * 4 + 3] > 16) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
      }
      const area = x1 < 0 ? 1 : ((x1 - x0 + 1) * (y1 - y0 + 1)) / (w * h);
      return { hasBg, solidBg, trimmable: !hasBg && x1 >= 0 && area < 0.9, keep: area };
    };
    const processImage = async (img, removeBg) => {
      const W = img.naturalWidth, H = img.naturalHeight;
      const c = document.createElement('canvas'); c.width = W; c.height = H;
      const g = c.getContext('2d', { willReadFrequently: true });
      g.drawImage(img, 0, 0);
      const id = g.getImageData(0, 0, W, H);
      const a = id.data;
      if (removeBg) {
        let r = 0, gg = 0, b = 0, n = 0;
        const sample = (x, y) => { const i = (y * W + x) * 4; r += a[i]; gg += a[i + 1]; b += a[i + 2]; n++; };
        for (let t = 0; t < 8; t++) { sample(t, t); sample(W - 1 - t, t); sample(t, H - 1 - t); sample(W - 1 - t, H - 1 - t); }
        r /= n; gg /= n; b /= n;
        const tol = 42, tol2 = tol * tol, soft2 = (tol * 2) * (tol * 2);
        const d2 = (i) => { const dr = a[i] - r, dg = a[i + 1] - gg, db = a[i + 2] - b; return dr * dr + dg * dg + db * db; };
        const N = W * H;
        const mask = new Uint8Array(N);
        const q = new Uint32Array(N);
        let qh = 0, qt = 0;
        const push = (p) => { if (!mask[p] && d2(p * 4) <= tol2) { mask[p] = 1; q[qt++] = p; } };
        for (let x = 0; x < W; x++) { push(x); push((H - 1) * W + x); }
        for (let y = 0; y < H; y++) { push(y * W); push(y * W + W - 1); }
        while (qh < qt) {
          const p = q[qh++], x = p % W;
          if (x > 0) push(p - 1);
          if (x < W - 1) push(p + 1);
          if (p >= W) push(p - W);
          if (p < N - W) push(p + W);
        }
        for (let p = 0; p < N; p++) {
          if (mask[p]) { a[p * 4 + 3] = 0; continue; }
          const x = p % W;
          const edge = (x > 0 && mask[p - 1]) || (x < W - 1 && mask[p + 1]) || (p >= W && mask[p - W]) || (p < N - W && mask[p + W]);
          if (edge) {
            const dd = d2(p * 4);
            if (dd < soft2) a[p * 4 + 3] = Math.round(a[p * 4 + 3] * Math.min(1, (Math.sqrt(dd) - tol) / tol));
          }
        }
      }
      let x0 = W, y0 = H, x1 = -1, y1 = -1;
      for (let y = 0; y < H; y++) {
        const row = y * W * 4;
        for (let x = 0; x < W; x++) {
          if (a[row + x * 4 + 3] > 8) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; y1 = y; }
        }
      }
      if (x1 < 0) throw new Error('empty');
      g.putImageData(id, 0, 0);
      const cw = x1 - x0 + 1, ch = y1 - y0 + 1;
      const out = document.createElement('canvas'); out.width = cw; out.height = ch;
      out.getContext('2d').drawImage(c, x0, y0, cw, ch, 0, 0, cw, ch);
      const blob = await new Promise((res) => out.toBlob(res, 'image/png'));
      if (!blob) throw new Error('export');
      return blob;
    };
    const makeThumb = (img) => new Promise((resolve) => {
      try {
        const k = Math.min(1, 800 / Math.max(img.naturalWidth, img.naturalHeight));
        const c = document.createElement('canvas');
        c.width = Math.max(1, Math.round(img.naturalWidth * k));
        c.height = Math.max(1, Math.round(img.naturalHeight * k));
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        c.toBlob((b) => resolve(b || null), 'image/png');
      } catch (e) { resolve(null); }
    });

    const mockSVG = (d, sz, small) => {
      const g = G(d);
      const [cName, cHex] = colorOf(g);
      const ink = isLight(cHex) ? '#231F20' : '#FFF8E7';
      const k = g.w / 36;
      let body = '';
      let place = g.centerName || 'Front';
      if (sz) {
        const pl = placeOf(d, sz);
        const names = { center: g.centerName || 'Front', left: 'Left chest', right: 'Right chest' };
        const key = Object.keys(g.places).find((p) => g.places[p] === pl);
        place = key ? names[key] : 'Your placement';
        const cx = pl.cx;
        const x = cx - sz.w / 2, y = topY(pl, sz);
        const art = d.url
          ? `<image href="${d.url}" x="${x}" y="${y}" width="${sz.w}" height="${sz.h}" preserveAspectRatio="none"/>`
          : `<rect x="${x}" y="${y}" width="${sz.w}" height="${sz.h}" fill="rgba(250,178,25,.35)"/><text x="${cx}" y="${y + sz.h / 2 + 0.3 * k}" text-anchor="middle" font-size="${Math.min(1, sz.w / 6)}" font-weight="800" fill="${ink}">Your design</text>`;
        const lab = `font-size="${(small ? 1.2 : 0.95) * k}" font-weight="800" fill="${ink}"`;
        body = `<g data-drag="${d.key}" class="bee-bs__drag"><title>Drag to move</title>${art}<rect x="${x}" y="${y}" width="${sz.w}" height="${sz.h}" fill="rgba(0,0,0,0)" stroke="#E09A00" stroke-width="${0.1 * k}" stroke-dasharray="${0.4 * k} ${0.25 * k}"/>`
          + `<text x="${cx}" y="${y - 0.7 * k}" text-anchor="middle" ${lab}>${sz.w}${IN}</text>`
          + `<text x="${x + sz.w + 0.75 * k}" y="${y + sz.h / 2 + 0.35 * k}" ${lab}>${sz.h}${IN}</text>`
          + [['nw', x, y], ['ne', x + sz.w, y], ['sw', x, y + sz.h], ['se', x + sz.w, y + sz.h]].map(([c, hx, hy]) => `<circle data-resize="${c}" class="bee-bs__handle is-${c}" cx="${hx}" cy="${hy}" r="${(small ? 0.75 : 0.45) * k}" fill="#fff" stroke="#E09A00" stroke-width="${(small ? 0.2 : 0.12) * k}"><title>Drag to resize</title></circle>`).join('')
          + '</g>';
      }
      const a = g.area;
      const areaEl = (a && !small) ? `<rect x="${a.x}" y="${a.y}" width="${a.w}" height="${a.h}" fill="none" stroke="rgba(35,31,32,.35)" stroke-width="${0.06 * k}" stroke-dasharray="${0.3 * k} ${0.2 * k}"/><text x="${a.x + a.w / 2}" y="${a.y + a.h + 0.75 * k}" text-anchor="middle" font-size="${0.6 * k}" font-weight="700" fill="rgba(35,31,32,.6)">Print area ${a.w}${IN} × ${a.h}${IN}</text>`
        : (a ? `<rect x="${a.x}" y="${a.y}" width="${a.w}" height="${a.h}" fill="none" stroke="rgba(35,31,32,.35)" stroke-width="${0.08 * k}" stroke-dasharray="${0.4 * k} ${0.25 * k}"/>` : '');
      const r = g.ruler;
      const ruler = (small || !r) ? '' : `<g stroke="${ink}" stroke-width=".07" opacity=".55"><path d="M${r.x0} ${r.y}H${r.x1}M${r.x0} ${r.y - 0.5}v1M${r.x1} ${r.y - 0.5}v1"/></g><text x="${(r.x0 + r.x1) / 2}" y="${r.y - 0.5}" text-anchor="middle" font-size=".75" font-weight="700" fill="${ink}" opacity=".7">${r.text}</text>`;
      const sid = `bsShade${small ? 'm' : ''}`;
      return {
        place,
        svg: `<svg viewBox="${g.vb}"${g.photo ? ' style="filter:none;overflow:hidden;border-radius:16px;background:#fff"' : ''} role="img" aria-label="${esc(place)} preview on a ${esc(cName.toLowerCase())} ${esc(g.name.toLowerCase())}"><defs><linearGradient id="${sid}" x1="0" x2="1"><stop offset="0" stop-color="#000" stop-opacity=".07"/><stop offset=".22" stop-color="#000" stop-opacity="0"/><stop offset=".78" stop-color="#000" stop-opacity="0"/><stop offset="1" stop-color="#000" stop-opacity=".07"/></linearGradient></defs>`
          + (g.photo
            ? `<image href="${g.photo}" x="0" y="0" width="${g.img}" height="${g.img}"/>`
            : (g.under ? g.under(cHex) : '')
              + `<path d="${g.body}" fill="${cHex}" stroke="${LINE}" stroke-width="${0.12 * k}" stroke-linejoin="round"/><path d="${g.body}" fill="url(#${sid})"/>`
              + (g.over ? g.over(cHex) : ''))
          + `${areaEl}${ruler}${body}</svg>`
      };
    };

    const priceFor = (sz, fin) => {
      if (!sz) return null;
      if (sz.w > data.maxSize || sz.h > data.maxSize || sz.w < data.minSize || sz.h < data.minSize) return null;
      const area = Math.round(sz.w * sz.h * 100) / 100;
      const t = tierFor(area, fin);
      return t ? { ...t, sqin: area } : null;
    };

    /* ---------- card markup ---------- */
    const cardHTML = (d, n) => `
      <header class="bee-bs__card-head">
        <span class="bee-bs__num">${n}</span>
        <span class="bee-bs__thumb">${esc((d.name.split('.').pop() || 'FILE').toUpperCase().slice(0, 4))}</span>
        <div class="bee-bs__card-meta"><strong title="${esc(d.name)}">${esc(d.name)}</strong><small data-c-sum>Pick a size</small><small class="bee-bs__up" data-c-up></small></div>
        <strong class="bee-bs__card-price" data-c-price></strong>
        <button type="button" class="bee-bs__icon-btn" data-c-toggle aria-expanded="true" aria-label="Show or hide options">${ICON_CHEV}</button>
        <button type="button" class="bee-bs__icon-btn" data-c-remove aria-label="Remove ${esc(d.name)}">${ICON_X}</button>
        <span class="bee-bs__bar-up" data-c-bar aria-hidden="true"></span>
      </header>
      <div class="bee-bs__card-body">
        <p class="bee-bs__measure" data-c-measure></p>
        <div class="bee-bs__ask"><strong>Select size</strong></div>
        <div class="bee-bs__opt"><span class="bee-bs__opt-n">1</span><span data-c-own-title>Recommended size<small>The largest size your file prints sharp. Want it smaller? Just type a new width or height.</small></span></div>
        <div class="bee-bs__opt"><span class="bee-bs__opt-n">2</span><span data-c-opt2>Or pick a popular size<small>Your design fits inside the box and keeps its shape</small></span></div>
        <div data-c-groups></div>
        <div class="bee-bs__own" data-c-own>
          <button type="button" class="bee-bs__own-head" data-c-best><span class="bee-bs__best-ico" aria-hidden="true">${ICON_CHECK}</span><span class="bee-bs__own-label" data-c-own-label>Recommended for your file</span><em data-c-best-price></em></button>
          <details class="bee-bs__more bee-bs__more--exact" data-c-exact-wrap open><summary>Or type your own size</summary>
          <div class="bee-bs__dims">
            <label><span>Width</span><input type="number" min="${data.minSize}" max="${data.maxSize}" step="0.1" inputmode="decimal" data-c-w><em>in</em></label>
            <button type="button" class="bee-bs__lock" data-c-lock aria-pressed="true" title="Keep proportions">${ICON_LOCK}<span class="bee-sr">Keep proportions</span></button>
            <label><span>Height</span><input type="number" min="${data.minSize}" max="${data.maxSize}" step="0.1" inputmode="decimal" data-c-h><em>in</em></label>
          </div>
          <p class="bee-bs__own-foot"><span data-c-lock-note>🔒 Proportions locked: change one side and the other follows.</span><button type="button" class="bee-bs__reset" data-c-reset hidden>Back to recommended</button></p>
          </details>
        </div>
        <button type="button" class="bee-bs__browse" data-c-std hidden></button>
        <p class="bee-bs__note" data-c-note></p>
        <div class="bee-bs__tools" data-c-tools hidden></div>
        <div class="bee-bs__qa" data-c-qa hidden></div>
        <div class="bee-bs__ask bee-bs__ask--2"><strong>Finish &amp; quantity</strong></div>
        ${hasPrecut ? `<div class="bee-bs__label">Finish</div>
        <div class="bee-bs__seg" role="group" aria-label="Finish">
          <button type="button" data-c-fin="roll" aria-pressed="true">Roll (uncut)</button>
          <button type="button" data-c-fin="precut" aria-pressed="false">Pre-cut<small>+${fmt(precutFee)}</small></button>
        </div>
        <p class="bee-bs__finhelp">Roll: you cut them apart. Pre-cut: trimmed and ready to place.</p>` : ''}
        <div class="bee-bs__label">Quantity</div>
        <div class="bee-bs__qtyline">
          <div class="bee-bs__qty">
            <button type="button" data-c-qty="-1" aria-label="Decrease quantity">−</button>
            <input type="number" min="1" max="9999" inputmode="numeric" value="${d.qty}" aria-label="Quantity" data-c-qty-input>
            <button type="button" data-c-qty="1" aria-label="Increase quantity">+</button>
          </div>
          <span class="bee-bs__each" data-c-each></span>
        </div>
        <details class="bee-bs__more bee-bs__more--mock" data-c-mock-wrap open><summary>See it on a shirt (optional)</summary><figure class="bee-bs__mini" data-c-mini></figure></details>
        <details class="bee-bs__instr"><summary>Need an artwork change? Add instructions</summary><textarea rows="2" placeholder="Background removal, color changes, exact placement…" data-c-notes></textarea></details>
      </div>`;

    /* sizes made for the design's own shape (like 3″×2″, 5.5″×4″ for a 1.4:1 logo) */
    const TAILOR = [
      ['Small', 'Hat logos, left chest, labels', [2, 3, 3.5, 4]],
      ['Medium', 'Chest prints, youth tees', [5, 6, 7, 8]],
      ['Large', 'Full front, back, oversized', [9, 10, 11, 12, 13, 14, 16]]
    ];
    const tailored = (d) => {
      if (!d.ratio) return [];
      const best = bestFit(d);
      const wide = d.ratio <= 1;
      const k = wide ? d.ratio : 1 / d.ratio; // short side ÷ long side
      const limit = data.maxSize; /* v8: show big sizes too (low-res files get a "may look soft" tag instead of hiding them) */
      const seen = new Set();
      const make = (L) => {
        const S = r1(L * k);
        if (S < data.minSize || L > data.maxSize) return null;
        const sz = wide ? [L, S] : [S, L];
        const key = sz.join('x');
        if (seen.has(key)) return null;
        seen.add(key);
        return sz;
      };
      const out = TAILOR.map(([title, sub, longs]) => ({ title, sub, exact: true, sizes: longs.filter((L) => L <= limit).map(make).filter(Boolean) }));
      if (best) {
        const top = make(Math.max(best.w, best.h));
        if (top && Math.max(...top) >= 8) out[2].sizes.push(top);
      }
      return out.filter((g) => g.sizes.length);
    };
    /* v8: popular sizes by where the print goes (longest side, design's shape kept) */
    /* v8: Ninja-style popular sizes. The design fits inside the box and keeps its shape. */
    const POPULAR = [[2,2,'Tag print / neck label'],[3,3,'Small tag / sleeve icon'],[4,2,'Name label / small chest text'],[4,4,'Left-chest logo'],[5,3,'Small badge logo'],[5,5,'Small chest / youth print'],[6,6,'Standard left chest / youth'],[7,7,'Small front (adult)'],[8,8,'Medium front print'],[9,9,'Large chest / medium front'],[9,11,'Vertical front / youth'],[10,10,'Standard adult front'],[11,11,'Adult full front'],[11,14,'Tall front / jersey'],[12,17,'Oversized front / hoodie']];
    const PRESETS = POPULAR.map(([w, h, l]) => [l, Math.max(w, h)]);
    const popLabel = (d) => {
      if (d.mode === 'best') return 'Recommended: largest sharp size for your file';
      if (d.mode === 'box') { const p = POPULAR.find(([w, h]) => d.box[0] === w && d.box[1] === h); return p ? `${p[0]}${IN} x ${p[1]}${IN} box · ${p[2]}` : 'Size box'; }
      return 'Custom size';
    };
    const presetsHTML = (d) => {
      const bf = bestFit(d);
      const bp = bf ? priceFor(bf, d.fin) : null;
      const rows = POPULAR.map(([bw, bh, label]) => {
        const fit = fitBox(d, bw, bh);
        const p = priceFor(fit, d.fin);
        return { key: `${bw}x${bh}`, area: bw * bh, text: `${bw}${IN} x ${bh}${IN} - ${label}${p ? '' : ' (too large)'}`, ok: !!p, on: d.mode === 'box' && d.box[0] === bw && d.box[1] === bh };
      });
      if (bf && bp) rows.push({ key: 'best', area: bf.w * bf.h, text: `${bf.w}${IN} x ${bf.h}${IN} - Largest sharp size (recommended)`, ok: true, on: d.mode === 'best' });
      rows.sort((a, b) => a.area - b.area);
      const sz = sizeOf(d);
      const custom = d.mode === 'custom' && sz ? `<option value="custom" selected>${sz.w}${IN} x ${sz.h}${IN} - Custom size</option>` : '';
      return `<label class="bee-bs__pop"><span>Popular sizes</span><select data-c-pop aria-label="Popular sizes">${custom}${rows.map((r) => `<option value="${r.key}"${r.on ? ' selected' : ''}${r.ok ? '' : ' disabled'}>${esc(r.text)}</option>`).join('')}</select></label>`;
    };
    const groupsHTML = (d) => (d.ratio && !d.std) ? presetsHTML(d) : groups.map((g) => `
      <div class="bee-bs__group">
        <div class="bee-bs__group-head">${esc(g.title)}${g.sub ? `<small>${esc(g.sub)}</small>` : ''}</div>
        <div class="bee-bs__chips">${g.sizes.map(([bw, bh]) => {
          const fit = g.exact ? { w: bw, h: bh } : fitBox(d, bw, bh);
          const p = priceFor(fit, d.fin);
          const on = g.exact ? (d.mode === 'custom' && r1(d.w) === bw && r1(d.h) === bh) : (d.mode === 'box' && d.box[0] === bw && d.box[1] === bh);
          const diff = d.std && d.ratio && (Math.abs(fit.w - bw) > 0.05 || Math.abs(fit.h - bh) > 0.05);
          return `<button type="button" class="bee-bs__chip" ${g.exact ? 'data-c-exact' : 'data-c-box'}="${bw}x${bh}" aria-pressed="${on}"${p ? '' : ' disabled'}><strong>${bw}${IN} × ${bh}${IN}</strong><small>${p ? fmt(p.price) : '—'}</small>${diff ? `<i>prints ${fit.w}×${fit.h}</i>` : ''}${(() => { const sh = sharpFit(d); return (sh && p && (fit.w > sh.w + 0.05 || fit.h > sh.h + 0.05)) ? '<i class="is-soft">may look soft</i>' : ''; })()}</button>`;
        }).join('')}</div>
      </div>`).join('');

    const measureText = (px) => ''; /* v8: no pixel/DPI maths shown to customers */
    const toolsHTML = (d) => {
      if (d.busy) return `<p class="bee-bs__tool-msg is-busy">${d.busy === 'bg' ? 'Removing the background…' : 'Trimming empty space…'} This can take a few seconds.</p>`;
      const i = d.info;
      if (!i) return '';
      let h = '';
      if (d.edit) {
        h += `<p class="bee-bs__tool-msg is-ok"><span><strong>✓ ${d.edit === 'bg' ? 'Background removed' : 'Empty space trimmed'}.</strong> Check the preview, then pick your size.</span><button type="button" class="bee-bs__tool-link" data-c-undo>Undo</button></p>`;
      } else if (i.hasBg && d.team) {
        h += `<p class="bee-bs__tool-msg is-ok"><span><strong>✓ Our team will remove the background</strong> by hand before printing. It's free.</span></p>`;
      } else if (i.hasBg) {
        h += `<p class="bee-bs__tool-msg is-warn"><span><strong>Your file has a background.</strong> DTF prints everything that isn’t transparent, so it would print as a solid box.</span></p>`
          + `<div class="bee-bs__tool-btns"><button type="button" class="bee-bs__tool" data-c-tool="bg">${i.solidBg ? 'Remove background' : 'Try automatic removal'}</button></div>`;
      } else if (i.trimmable) {
        h += `<p class="bee-bs__tool-msg"><span><strong>Your file has empty space around the design.</strong> Trim it so it prints at the right size and costs less.</span></p>`
          + `<div class="bee-bs__tool-btns"><button type="button" class="bee-bs__tool" data-c-tool="trim">Trim empty space</button></div>`;
      }
      if (i.hasBg) h += `<label class="bee-bs__team"><input type="checkbox" data-c-team ${d.team ? 'checked' : ''}><span>${d.edit === 'bg' ? 'Not happy with the result?' : 'Rather not do it yourself?'} <strong>Let our team remove the background by hand</strong> (free).</span></label>`;
      if (d.err) h += `<p class="bee-bs__tool-msg is-err"><span>${d.err}</span></p>`;
      return h;
    };
    const undoEdit = (d) => {
      if (!d.edit) return;
      if (d.url && d.url !== d.orig.url) URL.revokeObjectURL(d.url);
      Object.assign(d, { file: d.orig.file, url: d.orig.url, px: d.orig.px, ratio: d.orig.ratio, thumb: d.orig.thumb, measure: d.orig.measure, edit: null });
      d.tooBig = !up.url && d.file.size > SHOPIFY_MAX;
      d.el.querySelector('.bee-bs__thumb').innerHTML = `<img src="${d.url}" alt="">`;
      if (d.origJob) { d.job = d.origJob; paintUp(d); }
      if (d.mode === 'custom' && d.lock && d.ratio && d.w) d.h = r1(d.w * d.ratio);
    };
    const runTool = async (d, kind) => {
      d.busy = kind; d.err = '';
      render();
      await frame();
      try {
        const img = await loadImg(d.orig.url);
        const blob = await processImage(img, kind === 'bg');
        const base = d.orig.file.name.replace(/\.[^.]+$/, '');
        const file = new File([blob], `${base}-${kind === 'bg' ? 'no-background' : 'trimmed'}.png`, { type: 'image/png' });
        const url = URL.createObjectURL(file);
        const im2 = await loadImg(url);
        if (d.url && d.url !== d.orig.url) URL.revokeObjectURL(d.url);
        d.file = file; d.url = url;
        d.px = { w: im2.naturalWidth, h: im2.naturalHeight };
        d.ratio = im2.naturalHeight / im2.naturalWidth;
        d.measure = `${measureText(d.px)} <span class="bee-bs__tag">Edited</span>`;
        d.thumb = makeThumb(im2);
        d.edit = kind;
        d.team = false;
        d.tooBig = !up.url && file.size > SHOPIFY_MAX;
        d.el.querySelector('.bee-bs__thumb').innerHTML = `<img src="${url}" alt="">`;
        if (up.url) { d.job = startUpload(d, file); paintUp(d); }
        if (d.mode === 'custom' && d.lock && d.w) d.h = r1(d.w * d.ratio);
      } catch (e) {
        d.err = 'Sorry, we couldn’t edit this file automatically. Our team can fix it for you: add a note in “Need an artwork change?” below.';
      }
      d.busy = null;
      render();
    };

    /* tee placement: default spot, presets and dragging (inches on the 36×34 tee) */
    const placeOf = (d, sz) => {
      const g = G(d);
      return d.pos || ((g.auto && sz && sz.w <= 5 && sz.h <= 5) ? g.places.left : g.places.center);
    };
    /* presets give the top edge (y) or, centered in a print area, the middle (cy) */
    const topY = (pl, sz) => (pl.cy != null ? pl.cy - (sz ? sz.h : 0) / 2 : pl.y);
    const clampPos = (d, sz, cx, y) => {
      const b = G(d).box;
      return { cx: Math.min(b.x1, Math.max(b.x0, cx)), y: Math.min(Math.max(b.y0, b.y1 - (sz ? sz.h : 0)), Math.max(b.y0, y)) };
    };
    const dragOn = (box) => {
      box.addEventListener('pointerdown', (e) => {
        const g = e.target.closest('[data-drag]');
        if (!g) return;
        const d = designs.find((x) => x.key === g.dataset.drag);
        const svg = g.ownerSVGElement;
        if (!d || !svg) return;
        e.preventDefault();
        const sz = sizeOf(d);
        const handle = e.target.closest('[data-resize]');
        if (handle && sz) {
          /* corner drag = new print size (keeps the design's shape, opposite corner stays put) */
          const corner = handle.dataset.resize;
          const m = svg.getScreenCTM().inverse();
          const toS = (ev) => new DOMPoint(ev.clientX, ev.clientY).matrixTransform(m);
          const pl = placeOf(d, sz);
          const x0 = pl.cx - sz.w / 2, y0 = topY(pl, sz);
          const ax = corner.includes('w') ? x0 + sz.w : x0;
          const ay = corner.includes('n') ? y0 + sz.h : y0;
          const ratio = d.ratio || sz.h / sz.w;
          const maxW = Math.min(data.maxSize, data.maxSize / ratio);
          const minW = Math.max(data.minSize, data.minSize / ratio);
          let raf = 0;
          try { box.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
          const resize = (ev) => {
            const p = toS(ev);
            let w = Math.max(Math.abs(p.x - ax), Math.abs(p.y - ay) / ratio);
            w = r1(Math.min(maxW, Math.max(minW, w)));
            const h = r1(w * ratio);
            d.mode = 'custom'; d.viaChip = false; d.lock = true; d.w = w; d.h = h;
            d.pos = { cx: (corner.includes('w') ? ax - w : ax) + w / 2, y: corner.includes('n') ? ay - h : ay };
            if (!raf) raf = requestAnimationFrame(() => { raf = 0; render(); });
          };
          const stop = () => {
            box.removeEventListener('pointermove', resize);
            box.removeEventListener('pointerup', stop);
            box.removeEventListener('pointercancel', stop);
            render();
          };
          box.addEventListener('pointermove', resize);
          box.addEventListener('pointerup', stop);
          box.addEventListener('pointercancel', stop);
          return;
        }
        const toSvg = (ev) => new DOMPoint(ev.clientX, ev.clientY).matrixTransform(svg.getScreenCTM().inverse());
        const p0 = toSvg(e);
        const base = placeOf(d, sz);
        const by = topY(base, sz);
        try { g.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
        g.classList.add('is-dragging');
        const move = (ev) => {
          const p = toSvg(ev);
          d.pos = clampPos(d, sz, base.cx + p.x - p0.x, by + p.y - p0.y);
          g.setAttribute('transform', `translate(${d.pos.cx - base.cx} ${d.pos.y - by})`);
        };
        const done = () => {
          g.removeEventListener('pointermove', move);
          g.removeEventListener('pointerup', done);
          g.removeEventListener('pointercancel', done);
          render();
        };
        g.addEventListener('pointermove', move);
        g.addEventListener('pointerup', done);
        g.addEventListener('pointercancel', done);
      });
    };

    /* ---------- render ---------- */
    const renderCard = (d, line) => {
      const el = d.el;
      const sz = sizeOf(d);
      const p = line.p;
      el.classList.toggle('is-active', d.key === activeKey);
      el.querySelector('[data-c-measure]').innerHTML = (d.measure || '') + (d.tooBig ? `<span class="bee-bs__warn">This file is ${mb(d.file.size)}. The limit is 20 MB, so please upload a smaller file.</span>` : '');
      const best = bestFit(d);
      const ownOn = d.mode === 'best' || (d.mode === 'custom' && !d.viaChip);
      const ownSz = ownOn ? sz : (best || sz);
      const isBest = best && ownSz && ownSz.w === best.w && ownSz.h === best.h;
      el.querySelector('[data-c-own]').classList.toggle('is-on', !!ownOn);
      el.querySelector('.bee-bs__own-head[data-c-best]').setAttribute('aria-pressed', String(!!ownOn));
      const op = ownSz ? priceFor(ownSz, d.fin) : null;
      el.querySelector('[data-c-best-price]').textContent = op ? fmt(op.price) : '';
      el.querySelector('[data-c-own-label]').textContent = (isBest ? 'Best fit for your file: ' : 'Your size: ') + (ownSz ? `${ownSz.w}${IN} × ${ownSz.h}${IN}` : '');
      const gd = G(d);
      const sharp = sharpFit(d);
      el.querySelector('[data-c-own-title]').innerHTML = (best && sharp && best.w < sharp.w - 0.05)
        ? `Recommended for a ${esc(gd.name.toLowerCase())}<small>Sized to fit a typical ${esc(gd.fit.where)} and print sharp. Want it different? Just type a new width or height.</small>`
        : best
        ? 'Recommended size<small>The largest size your file prints sharp. Want it smaller? Just type a new width or height.</small>'
        : `Your size<small>Type the width or height you want, in inches (up to ${data.maxSize}${IN} on each side).</small>`;
      el.querySelector('[data-c-reset]').hidden = !(best && d.mode === 'custom' && !isBest);
      el.querySelector('[data-c-lock-note]').textContent = d.lock && d.ratio ? '🔒 Proportions locked: change one side and the other follows.' : '🔓 Unlocked: width and height change separately.';
      el.querySelector('[data-c-groups]').innerHTML = groupsHTML(d);
      const tl = !!(d.ratio && !d.std);
      const ar = d.ratio ? (d.ratio <= 1 ? `${(1 / d.ratio).toFixed(1)} : 1` : `1 : ${d.ratio.toFixed(1)}`) : '';
      el.querySelector('[data-c-opt2]').innerHTML = tl
        ? (() => { const bf = bestFit(d); return bf ? `We picked the best size for you: ${bf.w}${IN} × ${bf.h}${IN}<small>That's the largest size your file prints sharp. Want a different size? Pick a popular size below or type your own width or height.</small>` : `Choose print size<small>Pick a popular size below or type your own width or height.</small>`; })()
        : 'Or pick a standard size<small>Your design fits inside the box and keeps its shape</small>';
      const exWrap = el.querySelector('[data-c-exact-wrap]');
      if (exWrap && d.mode === 'custom' && !d.viaChip && !exWrap.open) exWrap.open = true;
      const stdBtn = el.querySelector('[data-c-std]');
      stdBtn.hidden = true; d.std = false; /* v8: one size list, made for the design's shape (standard boxes printed smaller than their label) */
      stdBtn.textContent = tl ? 'Browse standard sizes (2″×2″, 4″×4″, 11″×11″…)' : '← Back to sizes made for your design';
      const tools = el.querySelector('[data-c-tools]');
      const th = toolsHTML(d);
      tools.hidden = !th;
      tools.innerHTML = th;
      const mini = el.querySelector('[data-c-mini]');
      if (sz && (d.url || d.mode)) {
        const m = mockSVG(d, sz, true);
        mini.innerHTML = `<div class="bee-bs__places bee-bs__gar" role="group" aria-label="Preview on">${garBtnsHTML(d.garment || 'tee', 'data-c-gar')}</div>${m.svg}<figcaption>${esc(gd.name)} · ${m.place} · ${sz.w}${IN} × ${sz.h}${IN} · drag to move, pull a corner to resize</figcaption>`;
        mini.hidden = false;
      } else mini.hidden = true;
      const qa = el.querySelector('[data-c-qa]');
      const q = quality(d, sz);
      if (q.msgs.length && p) {
        qa.hidden = false;
        qa.className = `bee-bs__qa is-${q.level}`;
        qa.innerHTML = q.msgs.map((m) => `<p>${m}</p>`).join('')
          + (q.level === 'bad' ? `<label class="bee-bs__ack"><input type="checkbox" data-c-ack ${acked(d, sz) ? 'checked' : ''}><span>I understand and want it printed at this size anyway.</span></label>` : '');
      } else { qa.hidden = true; qa.innerHTML = ''; }
      const wIn = el.querySelector('[data-c-w]'), hIn = el.querySelector('[data-c-h]');
      if (document.activeElement !== wIn) wIn.value = sz ? sz.w : (d.w || '');
      if (document.activeElement !== hIn) hIn.value = sz ? sz.h : (d.h || '');
      const lock = el.querySelector('[data-c-lock]');
      lock.setAttribute('aria-pressed', String(d.lock && !!d.ratio));
      lock.disabled = !d.ratio;
      el.querySelectorAll('[data-c-fin]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.cFin === d.fin)));
      const qIn = el.querySelector('[data-c-qty-input]');
      if (document.activeElement !== qIn) qIn.value = d.qty;

      const note = el.querySelector('[data-c-note]');
      const sum = el.querySelector('[data-c-sum]');
      const priceEl = el.querySelector('[data-c-price]');
      const each = el.querySelector('[data-c-each]');
      if (!sz) {
        note.innerHTML = d.mode ? '' : 'Measuring your file…';
        sum.textContent = 'Pick a size';
        priceEl.textContent = '';
        each.textContent = '';
        return;
      }
      if (!p) {
        note.innerHTML = `<span class="bee-bs__warn">${sz.w}${IN} × ${sz.h}${IN} is larger than we print by size (max ${data.maxSize}${IN} per side, ${maxArea} in²). Try a smaller size or a gang sheet.</span>`;
        sum.textContent = `${sz.w}${IN} × ${sz.h}${IN} · too large`;
        priceEl.textContent = '';
        each.textContent = '';
        return;
      }
      {
        const isBest = d.mode === 'best';
        const what = popLabel(d);
        const q = quality(d, sz);
        note.innerHTML = `<span class="bee-bs__selected">${esc(what)}<br>Prints at <strong>${sz.w}${IN} × ${sz.h}${IN} · ${fmt(p.price)} each</strong></span>`;
      }
      sum.textContent = `${sz.w}${IN} × ${sz.h}${IN} · ${d.fin === 'precut' ? 'Pre-cut' : 'Roll'} · ×${d.qty}`;
      priceEl.textContent = fmt(line.total);
      each.innerHTML = `<strong>${fmt(line.eachNet)} each</strong>${line.save ? `<s>${fmt(p.price)}</s> · ` : ''}${fmt(line.total)} for ${d.qty}`;
    };

    const render = () => {
      const lines = designs.map((d) => {
        const p = priceFor(sizeOf(d), d.fin);
        return { d, p, qty: p ? d.qty : 0 };
      });
      const Q = lines.reduce((a, l) => a + l.qty, 0);
      const { cur, next } = tierInfo(Q);
      let total = 0;
      lines.forEach((l) => {
        if (!l.p) { l.total = 0; l.eachNet = 0; l.save = 0; return; }
        l.save = Math.floor(l.p.price * cur.pct / 100); // Shopify rounds the discount per unit
        l.eachNet = l.p.price - l.save;
        l.total = l.eachNet * l.qty;
        total += l.total;
      });
      lines.forEach((l, i) => { l.d.el.querySelector('.bee-bs__num').textContent = i + 1; renderCard(l.d, l); });

      const n = designs.length;
      drop.classList.toggle('is-compact', n > 0);
      dropTitle.textContent = n ? 'Add another design' : 'Upload your design';
      if (n && list.nextElementSibling !== drop) list.after(drop);
      else if (!n && dropHome.nextSibling !== drop) dropHome.after(drop);
      bulk.hidden = !n || !breaks.length;
      if (breaks.length) {
        breaksEl.innerHTML = `<li class="${cur.pct === 0 ? 'is-on' : ''}"><strong>1+</strong><span>Base price</span></li>` +
          breaks.map((t) => `<li class="${cur.qty === t.qty ? 'is-on' : ''}${next && next.qty === t.qty ? ' is-next' : ''}"><strong>${t.qty}+</strong><span>${t.pct}% off</span></li>`).join('');
        if (next && Q > 0) {
          const need = next.qty - Q;
          nudge.innerHTML = `<p><strong>Add ${need} more to get ${next.pct}% off</strong>All designs in this order count: ${Q} now, ${next.qty} needed.</p>`;
        } else if (cur.pct) {
          nudge.innerHTML = `<p><strong>${cur.pct}% bulk discount unlocked</strong>Applied automatically in your cart.</p>`;
        } else nudge.innerHTML = '';
      }
      const priced = lines.filter((l) => l.p);
      if (n) {
        totalEl.textContent = fmt(total);
        totalMeta.textContent = `${Q} transfer${Q === 1 ? '' : 's'} · ${n} design${n === 1 ? '' : 's'}${cur.pct ? ` · ${cur.pct}% off` : ''}`;
        if (barTotal) barTotal.textContent = fmt(total);
        if (barInfo) { const one = n === 1 ? sizeOf(designs[0]) : null; barInfo.textContent = one ? `${one.w}${IN} × ${one.h}${IN} · ×${Q}` : `${Q} transfer${Q === 1 ? '' : 's'} · ${n} design${n === 1 ? '' : 's'}`; }
      } else {
        totalMeta.textContent = 'Upload a design to see pricing';
      }
      addBtn.disabled = (n > 0 && priced.length !== n) || designs.some((d) => d.tooBig);
      showPreview();
    };

    const showPreview = () => {
      const d = designs.find((x) => x.key === activeKey);
      if (!d || (!d.url && !sizeOf(d))) { preview.hidden = true; stage.classList.remove('has-design'); return; }
      if (!d.url && view === 'flat') view = 'shirt';
      const sz = sizeOf(d);
      if (d.url) previewImg.src = d.url; else previewImg.removeAttribute('src');
      previewName.textContent = d.name;
      dimW.textContent = sz ? `${sz.w}${IN}` : '';
      dimH.textContent = sz ? `${sz.h}${IN}` : '';
      if (mockEl) {
        const m = mockSVG(d, sz, false);
        mockEl.innerHTML = m.svg;
        const q = quality(d, sz);
        mockCap.innerHTML = sz ? `<strong>${m.place}</strong> · ${sz.w}${IN} × ${sz.h}${IN} · true scale${q.level === 'bad' ? ' · <em>check the warning</em>' : ' · drag to move, pull a corner to resize'}` : '';
        const g = G(d);
        const pl = placeOf(d, sz);
        placeBtns.forEach((b) => { b.hidden = !g.places[b.dataset.place]; b.setAttribute('aria-pressed', String(g.places[b.dataset.place] === pl)); });
        if (placeBtns[0]) placeBtns[0].parentNode.hidden = view !== 'shirt' || Object.keys(g.places).length < 2;
        if (garWrap) { garWrap.innerHTML = garBtnsHTML(d.garment || 'tee', 'data-gar'); garWrap.hidden = view !== 'shirt'; }
        syncColors(g);
        const shirtBtn = viewBtns.find((b) => b.dataset.view === 'shirt');
        if (shirtBtn) shirtBtn.textContent = `On a ${g.name.toLowerCase()}`;
        mockEl.hidden = view !== 'shirt';
        flatEl.hidden = view !== 'flat';
        viewBtns.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.view === view)));
        const cur = colorOf(g)[1];
        colorBtns.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.color === cur)));
        colorWrap.hidden = view !== 'shirt' || g.colors.length < 2;
      }
      preview.hidden = false;
      stage.classList.add('has-design');
    };

    /* ---------- add / measure ---------- */
    const addDesign = (file) => {
      const d = { key: 'd' + (++seq), ref: Math.random().toString(36).slice(2, 10), file, name: file.name, url: null, px: null, ratio: null, vector: false, mode: null, box: [0, 0], w: null, h: null, lock: true, fin: (data.defaultFin === 'precut' && hasPrecut) ? 'precut' : 'roll', qty: 1, notes: '', measure: '', garment: lastGarment };
      const el = document.createElement('article');
      el.className = 'bee-bs__card is-open';
      d.el = el;
      el.innerHTML = cardHTML(d, designs.length + 1);
      designs.forEach((x) => { x.el.classList.remove('is-open'); x.el.querySelector('[data-c-toggle]').setAttribute('aria-expanded', 'false'); });
      designs.push(d);
      list.appendChild(el);
      activeKey = d.key;
      bindCard(d);
      if (up.url) {
        d.job = startUpload(d, file);
        d.origJob = d.job;
        paintUp(d);
      } else if (file.size > SHOPIFY_MAX) {
        d.tooBig = true;
      }

      const type = (file.type || '').toLowerCase();
      if (!/^image\/(png|jpe?g|webp|svg\+xml|gif)$/.test(type)) {
        d.measure = 'We can’t preview this file type. Pick a size box or enter the exact size — we’ll check your file before printing.';
        d.mode = 'box';
        d.box = [4, 4];
        render();
        return;
      }
      const url = URL.createObjectURL(file);
      const img = new Image();
      img.onload = () => {
        d.url = url;
        d.vector = type.includes('svg');
        const pw = img.naturalWidth, ph = img.naturalHeight;
        if (pw && ph) d.ratio = ph / pw;
        if (!d.vector && pw && ph) {
          d.px = { w: pw, h: ph };
          const fw = r1(pw / data.dpi), fh = r1(ph / data.dpi);
          d.measure = measureText(d.px);
          d.mode = 'best';
        } else {
          d.measure = 'Vector file — it stays sharp at any size.';
          d.mode = 'box';
          d.box = [11, 11];
        }
        d.el.querySelector('.bee-bs__thumb').innerHTML = `<img src="${url}" alt="">`;
        d.thumb = makeThumb(img);
        d.orig = { file, url, px: d.px, ratio: d.ratio, thumb: d.thumb, measure: d.measure };
        if (!d.vector) { try { d.info = analyze(img); } catch (e) { d.info = null; } }
        render();
      };
      img.onerror = () => { d.measure = 'Couldn’t read this image. Pick a size and we’ll check the file before printing.'; d.mode = 'box'; d.box = [4, 4]; render(); };
      img.src = url;
      render();
    };

    const bindCard = (d) => {
      const el = d.el;
      el.addEventListener('change', (e) => {
        const s = e.target.closest && e.target.closest('[data-c-pop]');
        if (!s) return;
        const v = s.value;
        if (v === 'best') { d.viaChip = false; d.mode = 'best'; }
        else if (v !== 'custom') { d.mode = 'box'; d.box = v.split('x').map(parseFloat); d.viaChip = true; }
        render();
      });
      const activate = () => {
        if (activeKey === d.key) return;
        activeKey = d.key;
        designs.forEach((x) => x.el.classList.toggle('is-active', x.key === activeKey));
        showPreview();
      };
      el.addEventListener('pointerdown', activate);
      el.addEventListener('focusin', activate);
      el.addEventListener('click', (e) => {
        const t = e.target.closest('button');
        if (!t) return;
        if (t.matches('[data-c-toggle]')) {
          const open = !el.classList.contains('is-open');
          el.classList.toggle('is-open', open);
          t.setAttribute('aria-expanded', String(open));
          return;
        }
        if (t.matches('[data-c-remove]')) {
          const i = designs.indexOf(d);
          designs.splice(i, 1);
          el.remove();
          if (d.url) URL.revokeObjectURL(d.url);
          if (activeKey === d.key) activeKey = (designs[Math.max(0, i - 1)] || {}).key || null;
          render();
          return;
        }
        if (t.matches('[data-c-tool]')) { runTool(d, t.dataset.cTool); return; }
        if (t.matches('[data-c-undo]')) { undoEdit(d); render(); return; }
        if (t.matches('[data-c-best]') || t.matches('[data-c-reset]')) {
          d.viaChip = false;
          if (bestFit(d)) d.mode = 'best';
          else { const cur = sizeOf(d); d.mode = 'custom'; if (cur) { d.w = cur.w; d.h = cur.h; } }
        }
        else if (t.matches('[data-c-std]')) d.std = !d.std;
        else if (t.matches('[data-c-exact]')) { const [w, h] = t.dataset.cExact.split('x').map(parseFloat); d.mode = 'custom'; d.lock = true; d.w = w; d.h = h; d.viaChip = true; }
        else if (t.matches('[data-c-box]')) { d.mode = 'box'; d.box = t.dataset.cBox.split('x').map(parseFloat); }
        else if (t.matches('[data-c-custom]')) {
          const sz = sizeOf(d);
          d.mode = 'custom';
          if (sz) { d.w = sz.w; d.h = sz.h; }
          render();
          el.querySelector('[data-c-w]').focus();
          return;
        }
        else if (t.matches('[data-c-lock]')) { d.lock = !d.lock; if (d.lock && d.ratio && d.w) d.h = r1(d.w * d.ratio); }
        else if (t.matches('[data-c-fin]')) d.fin = t.dataset.cFin;
        else if (t.matches('[data-c-gar]')) setGarment(d, t.dataset.cGar);
        else if (t.matches('[data-c-qty]')) d.qty = Math.min(9999, Math.max(1, d.qty + parseInt(t.dataset.cQty, 10)));
        else return;
        render();
      });
      el.addEventListener('change', (e) => {
        if (e.target.matches('[data-c-team]')) {
          d.team = e.target.checked;
          if (d.team && d.edit === 'bg') undoEdit(d);
          render();
          return;
        }
        if (!e.target.matches('[data-c-ack]')) return;
        d.ackFor = e.target.checked ? sigOf(sizeOf(d)) : null;
        errSubmit.hidden = true;
        render();
      });
      el.querySelector('[data-c-w]').addEventListener('input', (e) => {
        const w = parseFloat(e.target.value);
        if (d.mode !== 'custom') { const cur = (d.mode === 'best' ? sizeOf(d) : bestFit(d)) || sizeOf(d); if (cur) { d.w = cur.w; d.h = cur.h; } }
        d.mode = 'custom'; d.viaChip = false;
        d.w = w > 0 ? w : null;
        if (d.w && d.lock && d.ratio) d.h = r1(d.w * d.ratio);
        render();
      });
      el.querySelector('[data-c-h]').addEventListener('input', (e) => {
        const h = parseFloat(e.target.value);
        if (d.mode !== 'custom') { const cur = (d.mode === 'best' ? sizeOf(d) : bestFit(d)) || sizeOf(d); if (cur) { d.w = cur.w; d.h = cur.h; } }
        d.mode = 'custom'; d.viaChip = false;
        d.h = h > 0 ? h : null;
        if (d.h && d.lock && d.ratio) d.w = r1(d.h / d.ratio);
        render();
      });
      el.querySelector('[data-c-qty-input]').addEventListener('input', (e) => { d.qty = Math.min(9999, Math.max(1, parseInt(e.target.value, 10) || 1)); render(); });
      el.querySelector('[data-c-notes]').addEventListener('input', (e) => { d.notes = e.target.value; });
    };

    fileInput.addEventListener('change', () => {
      [...fileInput.files].forEach(addDesign);
      fileInput.value = '';
      errFile.hidden = true;
      drop.classList.remove('is-missing');
    });
    ['dragenter', 'dragover'].forEach((ev) => drop.addEventListener(ev, () => drop.classList.add('is-over')));
    ['dragleave', 'drop'].forEach((ev) => drop.addEventListener(ev, () => drop.classList.remove('is-over')));


    if (bar && 'IntersectionObserver' in window) {
      let addVisible = true, addAbove = false;
      const syncBar = () => {
        const show = !addVisible && (designs.length > 0 || addAbove);
        bar.classList.toggle('is-shown', show);
        bar.setAttribute('aria-hidden', String(!show));
        barBtn.tabIndex = show ? 0 : -1;
      };
      new IntersectionObserver(([en]) => { addVisible = en.isIntersecting; addAbove = en.boundingClientRect.top < 0; syncBar(); }).observe(addBtn);
      setInterval(syncBar, 600);
      barBtn.addEventListener('click', () => (designs.length ? addBtn.click() : drop.scrollIntoView({ behavior: 'smooth', block: 'center' })));
    }

    /* ---------- add to cart ---------- */
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      errSubmit.hidden = true;
      if (!designs.length) {
        errFile.hidden = false;
        drop.classList.add('is-missing');
        drop.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      const bad = designs.find((d) => !priceFor(sizeOf(d), d.fin));
      if (bad) {
        bad.el.classList.add('is-open');
        activeKey = bad.key;
        render();
        bad.el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        errSubmit.textContent = 'Pick a valid size for every design.';
        errSubmit.hidden = false;
        return;
      }
      const risky = designs.find((d) => quality(d, sizeOf(d)).level === 'bad' && !acked(d, sizeOf(d)));
      if (risky) {
        risky.el.classList.add('is-open');
        activeKey = risky.key;
        render();
        risky.el.querySelector('[data-c-qa]').scrollIntoView({ behavior: 'smooth', block: 'center' });
        errSubmit.textContent = `Please check the print-quality warning on design ${designs.indexOf(risky) + 1}: change the size, or tick the box to confirm.`;
        errSubmit.hidden = false;
        return;
      }
      addBtn.classList.add('is-busy');
      try {
        for (let i = 0; i < designs.length; i++) {
          const d = designs[i];
          const sz = sizeOf(d);
          const p = priceFor(sz, d.fin);
          addLabel.innerHTML = `<span class="bee-buzz">Bzzz…</span> ${designs.length > 1 ? `sending design ${i + 1} of ${designs.length}` : 'sending your design'}`;
          let driveUrl = null, origUrl = null;
          if (d.job) {
            const tick = setInterval(() => {
              if (d.job.state === 'busy') addLabel.innerHTML = `<span class="bee-buzz">Bzzz…</span> sending ${designs.length > 1 ? `design ${i + 1} of ${designs.length}` : 'your design'} ${Math.round(d.job.pct * 100)}%`;
            }, 250);
            try { driveUrl = await d.job.promise; } catch (e) { driveUrl = null; }
            if (d.origJob && d.origJob !== d.job) { try { origUrl = await d.origJob.promise; } catch (e) { origUrl = null; } }
            clearInterval(tick);
          }
          if (!driveUrl && d.file.size > SHOPIFY_MAX) {
            throw new Error(`${d.name} (${mb(d.file.size)}) could not be uploaded. Please check your connection and try again, or contact us.`);
          }
          const fd = new FormData();
          fd.append('id', p.id);
          fd.append('quantity', d.qty);
          fd.append('properties[Size]', `${sz.w}${IN} × ${sz.h}${IN}`);
          if (driveUrl) {
            const thumb = d.thumb ? await d.thumb : null;
            if (thumb) fd.append('properties[Design]', new File([thumb], `preview-${d.name.replace(/\.[^.]+$/, '')}.png`, { type: 'image/png' }));
            else fd.append('properties[Design]', d.name);
            fd.append('properties[_Print file]', driveUrl);
            fd.append('properties[_File name]', `${d.file.name} (${mb(d.file.size)})`);
            if (origUrl) fd.append('properties[_Original file]', origUrl);
          } else {
            fd.append('properties[Design]', d.file);
          }
          fd.append('properties[_Ref]', d.ref);
          if (G(d) !== GARMENTS.tee) fd.append('properties[Used on]', G(d).name);
          if (d.edit) fd.append('properties[Edited]', d.edit === 'bg' ? 'Background removed (automatic)' : 'Empty space trimmed');
          if (d.team) fd.append('properties[Background removal]', 'By our team (free)');
          if (d.notes && d.notes.trim()) fd.append('properties[Instructions]', d.notes.trim());
          fd.append('properties[_Area]', `${p.sqin} in²`);
          const q = quality(d, sz);
          if (q.level === 'bad') fd.append('properties[Customer approved]', q.tags.join(' + '));
          const res = await fetch(`${addUrl}.js`, { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
          if (!res.ok) {
            const j = await res.json().catch(() => ({}));
            throw new Error(`${d.name}: ${j.description || 'could not be added to the cart.'}`);
          }
        }
        location.href = cartUrl;
      } catch (ex) {
        errSubmit.textContent = ex.message;
        errSubmit.hidden = false;
        addBtn.classList.remove('is-busy');
        addLabel.textContent = addText;
      }
    });

    if (mockEl) dragOn(mockEl);
    dragOn(list);
    render();
  };
  const boot = () => document.querySelectorAll('.bee-bs').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
